// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_3x-7";
export var adjustableWidthBorderHeld = "_3x-8";
export var arrow = "_3x-3";
export var arrowButton = "_3x-4";
export var headerCell = "_3x-0";
export var help = "_3x-2";
export var icon = "_3x-1";
export var iconWrapper = "_3x-6";
export var noBorder = "_3x-b";
export var nonAdjustableWidthBorder = "_3x-9";
export var nonAdjustableWidthBorderHeld = "_3x-a";
export var textButton = "_3x-5";